// extracted by mini-css-extract-plugin
export var base = "_3y-0";
export var updateBanner = "_3y-1";